import { useContext, useEffect, useState } from "react";
import { authContext } from "../../../../context/auth/AuthContext";
import Boleteria from "../../page/boleteria/Boleteria";
import { useParams } from "react-router-dom";
import RestApi, { GetApi } from "../../../helpers/RestApi";
import { ActualizarReporte } from "../../../../helpers/ReporteHelper";
import clienteAntesala from "../../../config/Config";
import axios, { Axios } from "axios";
import AlertSuccess from "../../../../Alerts/AlertSucces";
import apiPrivateAntesala from "../../../config/ConfigPrivate";
import RestPrivateAntesala from "../../../helpers/RestPrivateApi";
import Alerts from "../../components/Alerts/Alerts";

const BoleteriaController = () => {
  const { user } = useContext(authContext);
  const { rol, status, auth } = user;

  const { id } = useParams();
  const [loading, setLoading] = useState(false);
  const [initialStateFilter, setInitialStateFilter] = useState({
    nombre_cliente: "",
    search: "",
  });
  const [filter, setFilter] = useState({
    ["filter[eventos_id]"]: id,
    per_page: 1000,
  });
  const [evento, setEvento] = useState(null);
  const [reportes, setReportes] = useState(null);
  const [extra, setExtra] = useState(false);

  const [campos, setCampos] = useState({
    fecha_compra: null,
    dni_cliente: null,
    telefono_cliente: null,
    email_cliente: null,
    tipo: null,
    multiplicador: null,
    monto: null,
    total: null,
    descuento: null,
    total_descuento: null,
    codigo_descuento: null,

    state: false,
  });

  let controller;

  const onClick = async (e, value) => {
    switch (e.target.name) {
      case "ver-mas":
        {
          setExtra(!extra);
        }
        break;
      case "registrar":
        {
          let formData = new FormData();
          formData.append("_method", "PUT");
          formData.append("registro_cliente", value.registrar);

          const response = await RestPrivateAntesala({
            url: `/reportes/${value.codigo}`,
            formData: formData,
            method: "post",
            setLoading: setLoading,
          });

          //Error
          if (response.status == 201 || response.status == 200) {
            let params = {
              ...filter,
            };

            fetch(setReportes, params, "/reportes");
            return Alerts({
              msg: "Alert",
              title: response.data.msg,
              code: "201",
              type: "success",
            });
          } else {
            if (typeof response.data.msg === "string") {
              return Alerts({
                msg: "Alert",
                title: response.data.msg,
                code: "400",
                type: "success",
              });
            }

            Object.keys(response.data.msg).map((key) => {
              return Alerts({
                msg: "Alert",
                title: response.data.msg[key][0],
                code: "401",
                type: "error",
              });
            });
          }
        }
        break;
    }
  };

  const onChange = async (e, value) => {
    switch (e.target.name) {
      //Filtro params
      case "search":
        {
          if (controller) controller.abort();

          controller = new AbortController();
          const signal = AbortController.signal;

          let params = {
            ...filter,
            ["filter[search]"]: e.target.value,
          };

          setFilter({ ...params });
          return fetch(setReportes, params, "/reportes", signal);
        }
        break;
      case "fecha":
        {
          let params = {
            ...filter,
            ["filter[fecha]"]: e.target.value,
          };

          setFilter({ ...params });
          return fetch(setReportes, params, "/reportes");
        }
        break;
      case "status":
        {
          if (e.target.value == "TODOS") {
            let params = {
              ...filter,
            };

            delete params["filter[fecha]"];

            setFilter({ ...params });
            return fetch(setReportes, params, "/reportes");
          }

          let params = {
            ...filter,
            ["filter[status]"]: e.target.value,
          };

          setFilter({ ...params });
          return fetch(setReportes, params, "/reportes");
        }
        break;
    }
  };

  const fetch = async (setData, params, url, signal) => {
    const response = await apiPrivateAntesala.get(url, { params, signal });
    if (response.status == 201 || response.status == 200) {
      setData(response.data);
    }
  };
  //##Evento
  useEffect(() => {
    if (!reportes) {
      let params = {
        ...filter,
      };

      return fetch(setEvento, params, `/eventos/${id}`);
    }
  }, []);

  useEffect(() => {
    if (!reportes) {
      let params = {
        ...filter,
      };

      return fetch(setReportes, params, "/reportes");
    }
  }, []);
  return (
    <Boleteria
      evento={evento}
      reportes={reportes}
      rol={rol}
      campos={campos}
      onClick={onClick}
      onChange={onChange}
      extra={extra}
    />
  );
};

export default BoleteriaController;
